import { i18n, defaultNS, flattenResources } from "@whatslly/commons/i18nService";

i18n.addResources(
  "en",
  defaultNS,
  flattenResources({
    etoken_expired_modal: {
      need_to_change_info: "Need to change your {{loginProvider}} information?",
      session_expired: "Session ended. Please reconnect to your {{loginProvider}} account.",
      logout: "Logout from Tuvis",
      continue_with_out_tuvis: "Continue without Tuvis",
      reconnect: "Reconnect",
      message_text_top: "Session ended. Please reconnect",
      message_text_bottom: "to your {{loginProvider}} account.",
    },
  })
);
i18n.addResources(
  "es",
  defaultNS,
  flattenResources({
    etoken_expired_modal: {
      need_to_change_info: "¿Necesitas cambiar tu información de {{loginProvider}}?",
      session_expired: "Sesión terminada. Por favor vuelva a conectar su cuenta de {{loginProvider}}.",
      logout: "Cerrar sesión",
      continue_with_out_tuvis: "Continuar sin Tuvis",
      reconnect: "Reconectar",
      message_text_top: "Sesión terminada. Por favor vuelva",
      message_text_bottom: "a conectar su cuenta de {{loginProvider}}.",
    },
  })
);
i18n.addResources(
  "pt",
  defaultNS,
  flattenResources({
    etoken_expired_modal: {
      need_to_change_info: "Precisa alterar as suas informações do {{loginProvider}}?",
      session_expired: "Sessão encerrada. Reconecte-se à sua conta da {{loginProvider}}.",
      logout: "Sair",
      continue_with_out_tuvis: "Continuar sem Tuvis",
      reconnect: "Reconectar",
      message_text_top: "Sessão encerrada. Por favor Reconecte-se",
      message_text_bottom: "à sua conta da {{loginProvider}}.",
    },
  })
);
